import React from 'react';
import { Virtuoso } from 'react-virtuoso';

export default function EndlessScroll({
  minHeight,
  data,
  itemContent,
  endReached,
  ...props
}) {
  return (
    <Virtuoso
      style={{ minHeight: minHeight }}
      data={data}
      itemContent={itemContent}
      endReached={endReached && endReached}
      {...props}
    />
  );
}
